<script lang="ts">
  import FAQs from '../components/FAQs.svelte'
  import Footer from '../components/Footer.svelte'
  import RoadmapHero from './components/RoadmapHero.svelte'
  import RoadmapHeroMobile from './components/RoadmapHeroMobile.svelte'
</script>

<div class="fade-in space-y-24 sm-desktop:space-y-52 lg-desktop:space-y-64">
  <RoadmapHeroMobile />
  <RoadmapHero />
  <FAQs />
  <Footer nextPage="Company" pageLink="/company" />
</div>
